import { render, staticRenderFns } from "./hubWiseOFPReport_KSA_new.vue?vue&type=template&id=d0d44bb4&"
import script from "./hubWiseOFPReport_KSA_new.vue?vue&type=script&lang=js&"
export * from "./hubWiseOFPReport_KSA_new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports